import React from "react";
import splash from '../../images/domino-splash-landing.svg';

const Banner = () => {
  return (
    <div className="relative md:flex md:flex-row md:place-content-evenly md:items-center mb-4 border-t-[0.5px] border-b-[0.5px] border-medium-dark-grey bg-very-dark-grey h-44">
       <div className="absolute inset-0 flex items-center justify-center h-full sm:h-auto w-full md:static md:inset-auto md:flex-none md:h-auto md:w-auto">
        <h1 className="text-white !text-3xl sm:!text-4xl md:!text-5xl !mb-1">Domino Documentation</h1>
      </div>
      <div className="h-full max-h-full">
        <img
          loading="lazy"
          src={splash}
          className="max-h-full w-auto max-w-xs object-contain m-auto "
          alt="domino splash image"
          id="domino-splash-image"
        />
      </div>
    </div>
  );
};

export default Banner;
